"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryTablePresenterImpl = void 0;
const common_1 = require("../common/common");
class SummaryTablePresenterImpl {
    viewModel;
    constructor() { }
    setViewModel(vm) {
        this.viewModel = vm;
    }
    initEmployeeStats(branchSettings, lockStatsColumnViews, showUserAlertBadges, roles) {
        if (!this.viewModel) {
            return;
        }
        const statsSettings = {
            roleCounts: [],
            showEmployeeWorkCountCell: branchSettings.isWorkCountInSummaryPage,
            showEmployeeVacationCountCell: branchSettings.isVacationCountInSummaryPage,
            showEmployeePTOCountCell: branchSettings.isPTOCountInSummaryPage,
            showEmployeeLaborCountCell: branchSettings.isLaborInSummaryPage,
            showStatsLock: lockStatsColumnViews,
            showUserAlertBadges,
        };
        roles.forEach(r => {
            statsSettings.roleCounts.push({
                id: r.getOriginalId(),
            });
        });
        this.viewModel.stats = statsSettings;
    }
    initDates(dates) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.oplusTimeDateStrings = dates.map(d => (0, common_1.yearMonthDateString)((0, common_1.toOplusTime)(d.getDate()), 'UTC'));
    }
    initEmployeeRows(userRows, branchUsers, groupUsers, showMemo, path, branchId) {
        if (!this.viewModel) {
            return;
        }
        const rows = [];
        const userIdToBranchUsers = {};
        for (const bu of branchUsers) {
            userIdToBranchUsers[bu.userID] = bu;
        }
        const userIdToGroupUsers = {};
        for (const gu of groupUsers) {
            userIdToGroupUsers[gu.userID] = gu;
        }
        // For now, expect the employee rows have already been sorted.
        userRows.forEach(dashView => {
            rows.push(this.dashViewToViewModel(dashView, showMemo, path, branchId, userIdToBranchUsers[dashView.id], userIdToGroupUsers[dashView.id]));
        });
        this.viewModel.employeeRows = rows;
    }
    dashViewToViewModel(u, showMemo, path, activeBranchId, branchUser, groupUser) {
        const name = this.computeName(u, branchUser, groupUser);
        return {
            userId: u.id,
            name: name || `not found (${u.id})`,
            link: `${path}/user/${u.id}?c=${activeBranchId}`,
            tags: branchUser?.tags || [],
            isBranchOwner: branchUser?.isOwner || false,
            isFake: u.isFake,
            isHelp: branchUser ? false : true,
            isDeleted: u.isDeleted,
            showMemoSummary: showMemo,
            memo: branchUser?.memo || "",
        };
    }
    computeName(u, branchUser, groupUser) {
        return branchUser?.name || groupUser?.name || u.name;
    }
}
exports.SummaryTablePresenterImpl = SummaryTablePresenterImpl;
